import {gql} from '@apollo/client';

export const boardQueries = {
    GET_ALL_BOARDS_FOR_MY_WORK: gql`
        query GetAllBaordsForMyWork($where: BoardFilterInput) {
            allAssigneedBoards(where: $where) {
                id
                title
                workspaceId
                boardType
                boardViews {
                    itemDataPresentationSummary
                    boardViewType
                }
                workspace {
                    slug
                }
                slug
            }
        }
    `,

    GET_BOARDS_BY_WORKSPACE_SLUG: gql`
        #Getting Board By Workspace ID
        query GetBoardsByWorkspaceSlug($workspaceSlug: String!) {
            allAssigneedBoards(where: {workspace: {slug: {eq: $workspaceSlug}}}) {
                id
                title
                workspaceId
                boardType
                description

                workspace {
                    slug
                }
                isSelected
                slug
            }
        }
    `,
    USERS_BY_BOARD_Slug: gql`
        #Getting Users By Board ID
        query GetUsersByBoardSlug($boardSlug: String!) {
            usersByBoardSlug(boardSlug: $boardSlug) {
                nodes {
                    id
                    email
                    firstName
                    status
                    lastName
                    userName
                }
            }
        }
    `,
    USERS_OF_ALL_BOARDS_BY_USER_SLUG: gql`
        #Getting Users Of All Boards By User ID
        query GetUsersOfAllBoardsByUserID(
            $workspaceSlug: String!
            $where: UserRelationListingResponseModelFilterInput
        ) {
            usersOfAllBoardsByUserSlug(workspaceSlug: $workspaceSlug, where: $where) {
                id
                email
                firstName
                status
                lastName
                userName
            }
        }
    `,
    GET_BOARD_SETTINGS: gql`
        query GetAllBoardSettings($boardSlug: String!, $controlType: String) {
            allBoardSettings(boardSlug: $boardSlug, controlType: $controlType) {
                id
                tenantId
                title
                uniqueId
                objectId
                objectType
                value
                groupName
                controlType
                order
                status
                isMulti
                data {
                    columnSize
                    isMultiValue
                    defaultValue {
                        options {
                            label
                            value
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                dataType
            }
        }
    `,
};
